module.exports = __webpack_public_path__ + "static/media/tr808_kick_03.bf9a5194.wav";